/**
 * @desc 布局组件
 * @time 2023-07-31 15:42:42
 * @user simxin
 */

import { Layout as RawLayout } from '@tencent/tea-component';
const { Body, Header, Footer, Sider, Content } = RawLayout;

type GetParamType<T extends (...args: any) => any> = Parameters<T>[0];

type LayoutProps = GetParamType<typeof RawLayout>;
type BodyProps = GetParamType<typeof Body>;
type ContentProps = GetParamType<typeof Content>;
type ContentHeaderProps = GetParamType<typeof Content.Header>;
type ContentBodyProps = GetParamType<typeof Content.Body>;

export const Layout = (props: LayoutProps) => <RawLayout {...props} />;
export const LayoutBody = (props: BodyProps) => <Body {...props} />;
export const LayoutHeader = (props: BodyProps) => <Header {...props} />;
export const LayoutSider = (props: BodyProps) => <Sider {...props} />;
export const LayoutFooter = (props: BodyProps) => <Footer {...props} />;
export const LayoutContent = (props: ContentProps) => <Content {...props} />;
export const ContentHeader = (props: ContentHeaderProps) => (
  <Content.Header {...props} />
);
export const ContentBody = (props: ContentBodyProps) => {
  const bodyProps = {
    full: true, // 默认全屏
    ...props,
  };
  return <Content.Body {...bodyProps} />;
};

Layout.Body = LayoutBody;
Layout.Content = LayoutContent;
LayoutContent.Header = ContentHeader;
LayoutContent.Body = ContentBody;
